module.exports = __webpack_public_path__ + "media/images/voice06-14bd06e937055686bd9efc883c698101.jpg";